import { render, staticRenderFns } from "./Catsafe.vue?vue&type=template&id=9f64fc70&"
import script from "./Catsafe.vue?vue&type=script&lang=js&"
export * from "./Catsafe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports